export const baseUrl = `${window.location.origin}/api/v1`;
export const isPreOrderForm = false;
export const pochtaWidgetKey = process.env.REACT_APP_BASE_IS_POCHTA_WIDGET_KEY || 30636;
export const cloudpaymentsKey =
	process.env.REACT_APP_BASE_IS_CLOUDPAYMENTS_KEY || 'pk_e5b782fa4f1bc12149a154eed9b91';

// айдишники для рассылок от unisender
export const unisenderNewslettersIDs = {
	novaya: {
		envelope: 9, // новостная рассылка(конверт)
		agenda: 22, // повестка
		donate: 11, // все соучастники, оформившие успешное пожертвование
		donate_rec_3000: 8, // рекурренты с суммой ежемесячного платежа от 3000
		donate_rec_1: 5, // рекурренты с суммой ежемесячного платежа 1-2999
		donate_1_time_xl: 4, // разовые жертвователи с платежом от 3000
		donate_1_time_s: 3, // разовые жертвователи с платежом 1-2999
		donate_unfinished: 7, // соучастники, которые не завершили оформление пожертвования
		shop: 1028
	},
	gorby: {
		room: 3
	}
};

export const defaultPage = `${window.location.origin}/subscribe`;

export const newsletters = [
	{
		slug: 'envelope',
		title: '«Конверт»',
		description:
			'Еженедельный (а может, скоро и чаще) рассказ о том, что важного и интересного появилось на наших платформах, новости редакции, материалы на актуальные темы, которые можно будет прочесть только в рассылке, ну или раньше, чем на других ресурсах',

		periodicity: 'Раз в неделю',
		subscriptionType: unisenderNewslettersIDs.novaya.envelope,
		client: 'novaya'
	},
	{
		slug: 'donate',
		title: '«Соучастнику. От главреда и редакции»',
		description:
			'Если вы&nbsp;захотите стать Соучастником &laquo;Новой&raquo;, чтобы помочь нам выживать фактически в&nbsp;окружении, в&nbsp;вашей почте появится еще одна рассылка&nbsp;&mdash; с&nbsp;эксклюзивными письмами от&nbsp;главного редактора и&nbsp;редакции &laquo;Новой&raquo;, рекомендациями, авторскими колонками, статьями, которые публикуются только здесь.',
		periodicity: 'Два раза в неделю',
		subscriptionType: unisenderNewslettersIDs.novaya.donate,
		client: 'novaya'
	},
	{
		slug: 'agenda',
		title: '«Не-Повестка»',
		description:
			'Медиа для тех, кому не&nbsp;все равно. Новости гражданского сопротивления, обзор громких политических процессов, хроника репрессий и&nbsp;последние слова новых политзаключенных. Мы&nbsp;должны сохранять память о&nbsp;Поступках. И&nbsp;не&nbsp;забыть палачей. Не&nbsp;можешь исправить&nbsp;&mdash; фиксируй.',
		periodicity: 'Два раза в месяц',
		subscriptionType: unisenderNewslettersIDs.novaya.agenda,
		client: 'novaya'
	},
	{
		slug: 'shop',
		title: '«Shop было»',
		description:
			'Рассылка со&nbsp;скидками для тех, кто покупает журналы, книги, одежду и&nbsp;сувениры в&nbsp;телеграм магазине партнеров &laquo;Новой газеты&raquo;&nbsp;&mdash; &laquo;Для дорогих людей&raquo;',
		periodicity: 'Раз в неделю',
		subscriptionType: unisenderNewslettersIDs.novaya.shop,
		client: 'novaya'
	},
	{
		slug: 'room',
		title: '«Читайная комната»',
		description:
			'Каждую неделю мы&nbsp;будем рассказывать вам об&nbsp;&laquo;альтернативной литературе&raquo;, которую, несмотря на&nbsp;репрессии, продолжают издавать и&nbsp;читать в&nbsp;России. Обзоры, рекомендации, наводки, анонсы новинок, информация об&nbsp;акциях и&nbsp;специальных предложениях. Книга всегда была и&nbsp;сейчас остается убежищем в&nbsp;трудное время. Давайте&nbsp;&mdash; читать.',
		periodicity: 'Раз в неделю',
		subscriptionType: unisenderNewslettersIDs.gorby.room,
		client: 'gorby'
	}
];

export const pageTitles = {
	terms: 'Пользовательское соглашение',
	privacy: 'Политика конфиденциальности'
};
